import React from 'react';
import Card from '../../../components/Card';
import SemesterLayout from '../../../components/SemesterLayout';

const Sem5 = ({ branch = "CSE" }) => {
  const notes = [
    { title: 'Compiler Design', link: `/notes/${branch.toLowerCase()}/CD` },
    { title: 'Computer Networks', link: `/notes/${branch.toLowerCase()}/CN` },
    { title: 'Design Analysis and Algorithms', link: `/notes/${branch.toLowerCase()}/DAA` },
    { title: 'Economics for Engineers', link: `/notes/${branch.toLowerCase()}/Economics` },
    { title: 'Operating Systems', link: `/notes/${branch.toLowerCase()}/OS` },
    { title: 'Software Engineering', link: `/notes/${branch.toLowerCase()}/SE` }
  ];

  return (
    <SemesterLayout
      branch={branch}
      semester="5th Semester"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {notes.map((note, index) => (
          <Card key={index} title={note.title} link={note.link} />
        ))}
      </div>
    </SemesterLayout>
  );
};

export default Sem5;
